import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 28px 0;
  background-color: white;
  width: 100%;
  position: fixed;
  z-index: 999;
`;

export default Container;
